export default "__VITE_ASSET__bb500b07__"